export const SUCCESS_MAX_RETAIL = "success@maxretail.com";
